import React, { useState, useEffect, useContext } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';
import { AppContext, DromoUploader, getTranslatedText } from '@nile/components';
import Loader from '@nile/mangifera/src/Components/Ticket/TicketCount';
import { getTicketConversationsImportFields } from '../Fields/ticketConversationsFields';
import { intlConverter } from '../utils/helpers';
import { ImportIdentifier } from '../constants';
const TicketConversationsUploader = (props) => {
  const { userToken, activator, onResults, onCancel } = props;
  const intl = useIntl();

  const appContext = useContext(AppContext);
  const { currentProduct } = appContext;

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [fields, setFields] = useState([]);

  useEffect(() => {
    setLoading(true);
    const ticketConversationsImportFields = getTicketConversationsImportFields(
      intl
    );
    const initFields = [...ticketConversationsImportFields];

    const selectFields = ticketConversationsImportFields.reduce(
      (acc, field, idx) => {
        if (field.type === 'select') acc[idx] = field.selectOptions;
        return acc;
      },
      {}
    );

    const promises = Object.values(selectFields);
    Promise.all(promises)
      .then((options) => {
        options.forEach((set, idx) => {
          const indexToModify = Object.keys(selectFields)[idx];
          initFields[indexToModify].selectOptions = set;
        });
        setFields([...intlConverter(intl, initFields)]);
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        setError(true);
        console.log(e);
      });
  }, []);

  if (loading) return <Loader loading />;

  if (error) return null;

  return (
    <DromoUploader
      settings={{
        importIdentifier: ImportIdentifier.TICKET_CONVERSATIONS,
        title: getTranslatedText(intl, 'migrate.data.ticketConversations.title')
      }}
      fields={fields}
      rowHooks={[(row) => row]}
      columnHooks={[(column) => column]}
      onResults={(response, metadata) => {
        if (onResults) onResults();
      }}
      onCancel={() => {
        if (onCancel) onCancel();
      }}
      activator={
        activator || (
          <div className="flex center actionListItemPadding ptr">
            <div className="mr-10 flex center">
              <SVGIcon name="TicketConversations" />
            </div>
            <FormattedMessage id="migrate.data.ticketConversations.title" />
          </div>
        )
      }
      userToken={userToken}
      backendSync
    />
  );
};

export default TicketConversationsUploader;
